import { render, staticRenderFns } from "./list.vue?vue&type=template&id=367a82a9&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=367a82a9&prod&lang=css"
import style1 from "./list.vue?vue&type=style&index=1&id=367a82a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367a82a9",
  null
  
)

export default component.exports